import React from 'react';
import type { IconProps } from '../types';

export const SidePanelCloseRight = (props: IconProps) => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.0014 16.1818L14.0917 12.0916L10.0014 8.00137"
      stroke="black"
    />
  </svg>
);

export default SidePanelCloseRight;
